const badgeLevelTypes = {
    SWITCH_MASTER_LEVEL_1: 'SWITCH_MASTER_LEVEL_1',
    SWITCH_MASTER_LEVEL_2: 'SWITCH_MASTER_LEVEL_2',
    SWITCH_MASTER_LEVEL_3: 'SWITCH_MASTER_LEVEL_3',
};

export default badgeLevelTypes;
